import { render, staticRenderFns } from "./ViewComplaint.vue?vue&type=template&id=7db0e458&scoped=true"
import script from "./ViewComplaint.vue?vue&type=script&lang=js"
export * from "./ViewComplaint.vue?vue&type=script&lang=js"
import style0 from "./ViewComplaint.vue?vue&type=style&index=0&id=7db0e458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db0e458",
  null
  
)

export default component.exports